module.exports = __webpack_public_path__ + "media/images/webpage/hotels/model_cases/family_three_generation-f39ff676d2d2bc4f73b51ebadb74c638.webp";